import { useFormikContext } from './useFormikContext'

export const useFormikIsDisabled = (
  initialDisableState: boolean | undefined,
) => {
  const { status } = useFormikContext()

  return status.shouldFieldsBeDisabled ? true : (initialDisableState ?? false)
}
